import { ReactNode } from 'react';

import { Box } from 'components/Box';

type Props = {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  xsmall?: boolean;
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  xlarge?: boolean;
  display?: string;
  children?: ReactNode;
};

export function Hide({
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  display,

  ...props
}: Props) {
  return (
    <Box
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      display={[xs, sm, md, lg, xl].map((n) =>
        n ? 'none' : display || 'block',
      )}
    >
      {children}
    </Box>
  );
}
